export class RestoreRdsNativePitrRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreToTime",
            "baseName": "restoreToTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "targetDatabaseName",
            "baseName": "targetDatabaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryInstanceClass",
            "baseName": "primaryInstanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryAvailabilityZone",
            "baseName": "primaryAvailabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "network",
            "baseName": "network",
            "type": "RdsNativePitrNetworkConfig",
            "format": ""
        },
        {
            "name": "advancedOptions",
            "baseName": "advancedOptions",
            "type": "RdsNativePitrAdvancedConfig",
            "format": ""
        },
        {
            "name": "clusterAdvancedOptions",
            "baseName": "clusterAdvancedOptions",
            "type": "RdsNativePitrClusterAdvancedConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRdsNativePitrRequest.attributeTypeMap;
    }
    constructor() {
    }
}
